import React, { useState, useEffect } from "react";
import "./TechnoAep.css";
import "./TechnoAepDigital.css";
import Hero from "../components/SchoolInnerPageBanner";
import data from "../data/technoAEPData";

const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;
const BASE = `${baseAPIUrl}assets/mpt_question_and_answers`;

const TechnoAep = () => {
  const exams = Object.keys(data);
  const mainExams = exams.filter((e) => e !== "Class XII" && e !== "Class XI" && e !== "Class VIII" && e !== "Class IX" && e !== "Class X");
  const classesExams = exams.filter((e) => e === "Class XII" || e === "Class XI");
  const classesExams2 = ["Class X", "Class IX", "Class VIII"];

  // --- Section 1 (JEE/NEET) ---
  const [activeExam1, setActiveExam1] = useState(() => {
    return mainExams[0] || "";
  });

  const [activeSubHeading1, setActiveSubHeading1] = useState(() => {
    if (mainExams[0] && data[mainExams[0]]) {
      return Object.keys(data[mainExams[0]])[0] || "";
    }
    return "";
  });

  const [activeYear1, setActiveYear1] = useState(() => {
    if (mainExams[0] && data[mainExams[0]]) {
      const subKeys = Object.keys(data[mainExams[0]]);
      if (subKeys[0] && data[mainExams[0]][subKeys[0]]) {
        const yearKeys = Object.keys(data[mainExams[0]][subKeys[0]]).sort((a, b) => b.localeCompare(a));
        return yearKeys[0] || "";
      }
    }
    return "";
  });

  const [activeMMTYear1, setActiveMMTYear1] = useState("");

  const subHeadings1 = activeExam1 && data[activeExam1] ? Object.keys(data[activeExam1]) : [];
  const years1 = activeExam1 && activeSubHeading1 && data[activeExam1][activeSubHeading1]
    ? Object.keys(data[activeExam1][activeSubHeading1]).sort((a, b) => b.localeCompare(a))
    : [];

  useEffect(() => {
    if (activeSubHeading1 === "MMT Series" && activeExam1 && activeYear1) {
      const classData = data[activeExam1]?.[activeSubHeading1]?.[activeYear1];
      if (classData) {
        const mmtYears = Object.keys(classData).sort((a, b) => b.localeCompare(a));
        if (!mmtYears.includes(activeMMTYear1)) {
          setActiveMMTYear1(mmtYears[0] || "");
        }
      } else {
        setActiveMMTYear1("");
      }
    } else {
      setActiveMMTYear1("");
    }
  }, [activeExam1, activeSubHeading1, activeYear1, activeMMTYear1]);

  const chapters1 = (() => {
    if (!activeExam1 || !activeSubHeading1 || !activeYear1) return [];
    if (activeSubHeading1 === "MMT Series") {
      if (!activeMMTYear1) return [];
      return data[activeExam1]?.[activeSubHeading1]?.[activeYear1]?.[activeMMTYear1]?.chapters || [];
    }
    return data[activeExam1]?.[activeSubHeading1]?.[activeYear1]?.chapters || [];
  })();

  const handleExamChange1 = (exam) => {
    setActiveExam1(exam);
    const subKeys = Object.keys(data[exam] || {});
    const firstSub = subKeys[0] || "";
    setActiveSubHeading1(firstSub);

    if (firstSub && data[exam][firstSub]) {
      const yearKeys = Object.keys(data[exam][firstSub]).sort((a, b) => b.localeCompare(a));
      setActiveYear1(yearKeys[0] || "");
    } else {
      setActiveYear1("");
    }
  };

  const handleSubHeadingChange1 = (subHeading) => {
    setActiveSubHeading1(subHeading);
    if (activeExam1 && data[activeExam1][subHeading]) {
      const yearKeys = Object.keys(data[activeExam1][subHeading]).sort((a, b) => b.localeCompare(a));
      setActiveYear1(yearKeys[0] || "");
    } else {
      setActiveYear1("");
    }
  };

  // --- Section 2 (Class XI / XII) ---
  const [activeExam2, setActiveExam2] = useState(() => {
    return classesExams[0] || "";
  });

  const [activeSubHeading2, setActiveSubHeading2] = useState(() => {
    if (classesExams[0] && data[classesExams[0]]) {
      return Object.keys(data[classesExams[0]])[0] || "";
    }
    return "";
  });

  const [activeYear2, setActiveYear2] = useState(() => {
    if (classesExams[0] && data[classesExams[0]]) {
      const subKeys = Object.keys(data[classesExams[0]]);
      if (subKeys[0] && data[classesExams[0]][subKeys[0]]) {
        const yearKeys = Object.keys(data[classesExams[0]][subKeys[0]]).sort((a, b) => b.localeCompare(a));
        return yearKeys[0] || "";
      }
    }
    return "";
  });

  const subHeadings2 = activeExam2 && data[activeExam2] ? Object.keys(data[activeExam2]) : [];
  const years2 = activeExam2 && activeSubHeading2 && data[activeExam2][activeSubHeading2]
    ? Object.keys(data[activeExam2][activeSubHeading2]).sort((a, b) => b.localeCompare(a))
    : [];

  const chapters2 = activeExam2 && activeSubHeading2 && activeYear2 && data[activeExam2][activeSubHeading2][activeYear2]
    ? data[activeExam2][activeSubHeading2][activeYear2].chapters || []
    : [];

  const handleExamChange2 = (exam) => {
    setActiveExam2(exam);
    const subKeys = Object.keys(data[exam] || {});
    const firstSub = subKeys[0] || "";
    setActiveSubHeading2(firstSub);

    if (firstSub && data[exam][firstSub]) {
      const yearKeys = Object.keys(data[exam][firstSub]).sort((a, b) => b.localeCompare(a));
      setActiveYear2(yearKeys[0] || "");
    } else {
      setActiveYear2("");
    }
  };

  const handleSubHeadingChange2 = (subHeading) => {
    setActiveSubHeading2(subHeading);
    if (activeExam2 && data[activeExam2][subHeading]) {
      const yearKeys = Object.keys(data[activeExam2][subHeading]).sort((a, b) => b.localeCompare(a));
      setActiveYear2(yearKeys[0] || "");
    } else {
      setActiveYear2("");
    }
  };

  // --- Section 3 (Class VIII / IX / X) ---
  const [activeExam3, setActiveExam3] = useState(() => {
    return classesExams2[0] || "";
  });

  const [activeSubHeading3, setActiveSubHeading3] = useState(() => {
    if (classesExams2[0] && data[classesExams2[0]]) {
      return Object.keys(data[classesExams2[0]])[0] || "";
    }
    return "";
  });

  const [activeYear3, setActiveYear3] = useState(() => {
    if (classesExams2[0] && data[classesExams2[0]]) {
      const subKeys = Object.keys(data[classesExams2[0]]);
      if (subKeys[0] && data[classesExams2[0]][subKeys[0]]) {
        const yearKeys = Object.keys(data[classesExams2[0]][subKeys[0]]).sort((a, b) => b.localeCompare(a));
        return yearKeys[0] || "";
      }
    }
    return "";
  });

  const subHeadings3 = activeExam3 && data[activeExam3] ? Object.keys(data[activeExam3]) : [];
  const years3 = activeExam3 && activeSubHeading3 && data[activeExam3][activeSubHeading3]
    ? Object.keys(data[activeExam3][activeSubHeading3]).sort((a, b) => b.localeCompare(a))
    : [];

  const chapters3 = activeExam3 && activeSubHeading3 && activeYear3 && data[activeExam3][activeSubHeading3][activeYear3]
    ? data[activeExam3][activeSubHeading3][activeYear3].chapters || []
    : [];

  const handleExamChange3 = (exam) => {
    setActiveExam3(exam);
    const subKeys = Object.keys(data[exam] || {});
    const firstSub = subKeys[0] || "";
    setActiveSubHeading3(firstSub);

    if (firstSub && data[exam][firstSub]) {
      const yearKeys = Object.keys(data[exam][firstSub]).sort((a, b) => b.localeCompare(a));
      setActiveYear3(yearKeys[0] || "");
    } else {
      setActiveYear3("");
    }
  };

  const handleSubHeadingChange3 = (subHeading) => {
    setActiveSubHeading3(subHeading);
    if (activeExam3 && data[activeExam3][subHeading]) {
      const yearKeys = Object.keys(data[activeExam3][subHeading]).sort((a, b) => b.localeCompare(a));
      setActiveYear3(yearKeys[0] || "");
    } else {
      setActiveYear3("");
    }
  };

  const getFileUrl = (fileName) => {
    if (!fileName) return "#";
    if (fileName.startsWith("http://") || fileName.startsWith("https://") || fileName.startsWith("/")) {
      return fileName;
    }
    return `${BASE}/${fileName}`;
  };

  return (
    <div className="academics-page">
      <Hero
        image="/pictures/image.jpg"
        alt="Academics"
      />

      {/* SECTION 1: JEE/NEET */}
      <section style={{ paddingBottom: "40px" }}>
        <div className="outer-container" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
          {/* EXAM BUTTONS 1 */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              marginBottom: "30px",
              flexWrap: "wrap",
            }}
          >
            {mainExams.map((exam) => (
              <button
                key={exam}
                className="techno-aep-digital-subject-btn"
                onClick={() => handleExamChange1(exam)}
                style={{
                  padding: "10px 22px",
                  border: "1px solid #641320",
                  background: activeExam1 === exam ? "#641320" : "#fff",
                  color: activeExam1 === exam ? "#fff" : "#641320",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                }}
              >
                {exam}
              </button>
            ))}
          </div>

          {/* SUB HEADING SECTION 1 */}
          {subHeadings1.length > 0 && (
            <div className="class-section">
              {subHeadings1.map((sub, index) => (
                <div
                  key={index}
                  className="class-box"
                  onClick={() => handleSubHeadingChange1(sub)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className={`icon-wrapper ${activeSubHeading1 === sub ? "active" : ""}`}
                  >
                    <div className="icon">
                      <img
                        src="/pictures/book.png"
                        alt="book"
                      />
                    </div>
                  </div>
                  <span style={{ fontWeight: activeSubHeading1 === sub ? "bold" : "normal" }}>
                    {sub}
                  </span>
                </div>
              ))}
            </div>
          )}

          {/* YEAR SECTION 1 */}
          {years1.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "40px",
                flexWrap: "wrap",
                marginTop: "20px",
              }}
            >
              {years1.map((year) => (
                <button
                  key={year}
                  className="techno-aep-digital-subject-btn"
                  onClick={() => setActiveYear1(year)}
                  style={{
                    padding: "10px 22px",
                    border: "1px solid #641320",
                    background: activeYear1 === year ? "#641320" : "#fff",
                    color: activeYear1 === year ? "#fff" : "#641320",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                >
                  {year}
                </button>
              ))}
            </div>
          )}

          {/* MMT YEAR SECTION 1 */}
          {activeSubHeading1 === "MMT Series" && activeYear1 && data[activeExam1]?.[activeSubHeading1]?.[activeYear1] && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "40px",
                flexWrap: "wrap",
                marginTop: "-20px",
              }}
            >
              {Object.keys(data[activeExam1][activeSubHeading1][activeYear1]).sort((a, b) => b.localeCompare(a)).map((year) => (
                <button
                  key={year}
                  className="techno-aep-digital-subject-btn"
                  onClick={() => setActiveMMTYear1(year)}
                  style={{
                    padding: "10px 22px",
                    border: "1px solid #641320",
                    background: activeMMTYear1 === year ? "#641320" : "#fff",
                    color: activeMMTYear1 === year ? "#fff" : "#641320",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                >
                  {year}
                </button>
              ))}
            </div>
          )}

          {/* CHAPTERS 1 */}
          <div className="master-card">
            {chapters1.length > 0 ? (
              chapters1.map((chapter, index) => (
                <div
                  className="maths-card"
                  key={index}
                  style={{
                    minWidth: "320px",
                    margin: "20px",
                    flex: "1 1 320px",
                  }}
                >
                  <h3
                    style={{
                      fontFamily: "lora",
                      fontSize: "1.3rem",
                      marginBottom: "20px",
                      color: "#641320",
                      borderBottom: "2px solid #641320",
                      paddingBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    {chapter.name}
                  </h3>

                  <div className="questionhub-button-grid">
                    {chapter.buttons && chapter.buttons.map((button, btnIndex) => (
                      <a
                        key={btnIndex}
                        href={getFileUrl(button.file)}
                        target="_blank"
                        rel="noreferrer"
                        className="techno-aep-digital-btn"
                        style={{
                          display: "block",
                          textDecoration: "none",
                          textAlign: "center",
                        }}
                      >
                        {button.label}
                      </a>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div className="no-chapter-box">
                <img
                  src="/pictures/book.png"
                  alt="No Chapters"
                  className="no-chapter-icon"
                />
                <h3>No Chapters Available</h3>
                <p>
                  Study materials, videos and assignments will be uploaded soon.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* HORIZONTAL RULE / SECTION DIVIDER */}
      <hr style={{ border: "none", borderTop: "2px solid #641320", opacity: 0.25, width: "80%", margin: "20px auto" }} />

      {/* SECTION 2: CLASS XII / XI */}
      <section style={{ paddingTop: "0px", paddingBottom: "40px" }}>
        <div className="outer-container" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
          {/* EXAM BUTTONS 2 */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              marginBottom: "30px",
              flexWrap: "wrap",
            }}
          >
            {classesExams.map((exam) => (
              <button
                key={exam}
                className="techno-aep-digital-subject-btn"
                onClick={() => handleExamChange2(exam)}
                style={{
                  padding: "10px 22px",
                  border: "1px solid #641320",
                  background: activeExam2 === exam ? "#641320" : "#fff",
                  color: activeExam2 === exam ? "#fff" : "#641320",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                }}
              >
                {exam}
              </button>
            ))}
          </div>

          {/* SUB HEADING SECTION 2 */}
          {subHeadings2.length > 0 && (
            <div className="class-section">
              {subHeadings2.map((sub, index) => (
                <div
                  key={index}
                  className="class-box"
                  onClick={() => handleSubHeadingChange2(sub)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className={`icon-wrapper ${activeSubHeading2 === sub ? "active" : ""}`}
                  >
                    <div className="icon">
                      <img
                        src="/pictures/book.png"
                        alt="book"
                      />
                    </div>
                  </div>
                  <span style={{ fontWeight: activeSubHeading2 === sub ? "bold" : "normal" }}>
                    {sub}
                  </span>
                </div>
              ))}
            </div>
          )}

          {/* YEAR SECTION 2 */}
          {years2.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "40px",
                flexWrap: "wrap",
                marginTop: "20px",
              }}
            >
              {years2.map((year) => (
                <button
                  key={year}
                  className="techno-aep-digital-subject-btn"
                  onClick={() => setActiveYear2(year)}
                  style={{
                    padding: "10px 22px",
                    border: "1px solid #641320",
                    background: activeYear2 === year ? "#641320" : "#fff",
                    color: activeYear2 === year ? "#fff" : "#641320",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                >
                  {year}
                </button>
              ))}
            </div>
          )}

          {/* CHAPTERS 2 */}
          <div className="master-card">
            {chapters2.length > 0 ? (
              chapters2.map((chapter, index) => (
                <div
                  className="maths-card"
                  key={index}
                  style={{
                    minWidth: "320px",
                    margin: "20px",
                    flex: "1 1 320px",
                  }}
                >
                  <h3
                    style={{
                      fontFamily: "lora",
                      fontSize: "1.3rem",
                      marginBottom: "20px",
                      color: "#641320",
                      borderBottom: "2px solid #641320",
                      paddingBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    {chapter.name}
                  </h3>

                  <div className="questionhub-button-grid">
                    {chapter.buttons && chapter.buttons.map((button, btnIndex) => (
                      <a
                        key={btnIndex}
                        href={getFileUrl(button.file)}
                        target="_blank"
                        rel="noreferrer"
                        className="techno-aep-digital-btn"
                        style={{
                          display: "block",
                          textDecoration: "none",
                          textAlign: "center",
                        }}
                      >
                        {button.label}
                      </a>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div className="no-chapter-box">
                <img
                  src="/pictures/book.png"
                  alt="No Chapters"
                  className="no-chapter-icon"
                />
                <h3>No Chapters Available</h3>
                <p>
                  Study materials, videos and assignments will be uploaded soon.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* HORIZONTAL RULE / SECTION DIVIDER */}
      <hr style={{ border: "none", borderTop: "2px solid #641320", opacity: 0.25, width: "80%", margin: "20px auto" }} />

      {/* SECTION 3: CLASS VIII / IX / X */}
      <section style={{ paddingTop: "0px", paddingBottom: "80px" }}>
        <div className="outer-container" style={{ paddingTop: "40px", paddingBottom: "0px" }}>
          {/* EXAM BUTTONS 3 */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              marginBottom: "30px",
              flexWrap: "wrap",
            }}
          >
            {classesExams2.map((exam) => (
              <button
                key={exam}
                className="techno-aep-digital-subject-btn"
                onClick={() => handleExamChange3(exam)}
                style={{
                  padding: "10px 22px",
                  border: "1px solid #641320",
                  background: activeExam3 === exam ? "#641320" : "#fff",
                  color: activeExam3 === exam ? "#fff" : "#641320",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                }}
              >
                {exam}
              </button>
            ))}
          </div>

          {/* SUB HEADING SECTION 3 */}
          {subHeadings3.length > 0 && (
            <div className="class-section">
              {subHeadings3.map((sub, index) => (
                <div
                  key={index}
                  className="class-box"
                  onClick={() => handleSubHeadingChange3(sub)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className={`icon-wrapper ${activeSubHeading3 === sub ? "active" : ""}`}
                  >
                    <div className="icon">
                      <img
                        src="/pictures/book.png"
                        alt="book"
                      />
                    </div>
                  </div>
                  <span style={{ fontWeight: activeSubHeading3 === sub ? "bold" : "normal" }}>
                    {sub}
                  </span>
                </div>
              ))}
            </div>
          )}

          {/* YEAR SECTION 3 */}
          {years3.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "40px",
                flexWrap: "wrap",
                marginTop: "20px",
              }}
            >
              {years3.map((year) => (
                <button
                  key={year}
                  className="techno-aep-digital-subject-btn"
                  onClick={() => setActiveYear3(year)}
                  style={{
                    padding: "10px 22px",
                    border: "1px solid #641320",
                    background: activeYear3 === year ? "#641320" : "#fff",
                    color: activeYear3 === year ? "#fff" : "#641320",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                >
                  {year}
                </button>
              ))}
            </div>
          )}

          {/* CHAPTERS 3 */}
          <div className="master-card">
            {chapters3.length > 0 ? (
              chapters3.map((chapter, index) => (
                <div
                  className="maths-card"
                  key={index}
                  style={{
                    minWidth: "320px",
                    margin: "20px",
                    flex: "1 1 320px",
                  }}
                >
                  <h3
                    style={{
                      fontFamily: "lora",
                      fontSize: "1.3rem",
                      marginBottom: "20px",
                      color: "#641320",
                      borderBottom: "2px solid #641320",
                      paddingBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    {chapter.name}
                  </h3>

                  <div className="questionhub-button-grid">
                    {chapter.buttons && chapter.buttons.map((button, btnIndex) => (
                      <a
                        key={btnIndex}
                        href={getFileUrl(button.file)}
                        target="_blank"
                        rel="noreferrer"
                        className="techno-aep-digital-btn"
                        style={{
                          display: "block",
                          textDecoration: "none",
                          textAlign: "center",
                        }}
                      >
                        {button.label}
                      </a>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div className="no-chapter-box">
                <img
                  src="/pictures/book.png"
                  alt="No Chapters"
                  className="no-chapter-icon"
                />
                <h3>No Chapters Available</h3>
                <p>
                  Study materials, videos and assignments will be uploaded soon.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TechnoAep;